import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { defaultMarkdownParser } from './parsers'
import { TextWrapper } from './Components'

/**
 * Markdown.
 *
 * Transform normal text to markdown text.
 *
 * @param {Object} props - Component Props.
 * @param [{string}] props.className - Style class for the markdown text wrapper.
 * @param {string} props.children - String with the text marked.
 * @param {string} props.parser - Parser to be used.
 *
 * @returns {React.ReactElement} - React element.
 *
 * @example // Basic example
 * <Markdown>"Hello I am `Normal Text` but I will markdown :smile:"</Markdown>
 */
const BaseMarkdown = ({
  className,
  children,
  'data-testid': dataTestId,
  parser,
}) => {
  const markdown = useMemo(() => {
    return parser(children)
  }, [children, parser])

  return (
    <TextWrapper className={className} data-testid={dataTestId}>
      {markdown}
    </TextWrapper>
  )
}

BaseMarkdown.defaultProps = {
  children: '',
  parser: defaultMarkdownParser,
}

BaseMarkdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  parser: PropTypes.func,
  'data-testid': PropTypes.string,
}

export const Markdown = styled(BaseMarkdown)`
  /* Prevents text for causing overflow */
  overflow-wrap: break-word;
  hyphens: auto;

  /* Prevents links for causing overflow */
  & a {
    white-space: normal;
    word-break: break-all;
  }
`

export default BaseMarkdown
